import React, { Fragment } from "react";
import { Row, Col, Input } from "antd";
import { useIntl } from "react-intl";

import Service from "./service";
import InputItem from "../../app/generic/inputItem";
import { canBeCod } from "../../../modules/consignmentFunctions";
import CashOnDeliveryItem from "../../app/generic/cashOnDeliveryItem";

export const defaultMaxCodAmoutInCzk = 200000;

const CashOnDelivery = ({
  rules,
  product,
  mainForm,
  disabled,
  pickupCountry,
  cashOnDelivery,
  formItemLayout,
  deliveryCountry,
  getFieldDecorator,
  deliveryCountryCurrencies,
}) => {
  const intl = useIntl();
  return rules.cashOnDelivery &&
    deliveryCountryCurrencies &&
    deliveryCountryCurrencies.length > 0 &&
    canBeCod(deliveryCountry, pickupCountry) &&
    canBeCod(pickupCountry, deliveryCountry, true) ? (
    <Row type="flex" align="middle">
      <Service
        hideRow
        label={intl.formatMessage({
          id: "consignment.cashOnDelivery",
          defaultMessage: "Dobírka",
        })}
        disabled={disabled}
        fieldName="cashOnDelivery"
        initialValue={cashOnDelivery}
        getFieldDecorator={getFieldDecorator}
      />
      <Col span={16}>
        {mainForm.getFieldValue("cashOnDelivery") && (
          <Input.Group>
            <CashOnDeliveryItem
              inlineLabel
              product={product}
              disabled={disabled}
              formItemLayout={formItemLayout}
              cashOnDelivery={cashOnDelivery}
              getFieldDecorator={getFieldDecorator}
              currencies={deliveryCountryCurrencies}
              productCurrencies={rules.cashOnDeliveryCurrencies}
            />
            <InputItem
              allowClear
              wrapperCol={5}
              variableSymbol
              disabled={disabled}
              label={intl.formatMessage({
                id: "consignment.services.variableSymbol",
                defaultMessage: "Variabilní symbol",
              })}
              fieldName="variableSymbol"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
              message={intl.formatMessage({
                id: "consignment.services.emptyVariableSymbol",
                defaultMessage: "Zadejte prosím variabilní symbol!",
              })}
              initialValue={cashOnDelivery && cashOnDelivery.variableSymbol}
            />
          </Input.Group>
        )}
      </Col>
    </Row>
  ) : (
    <Fragment />
  );
};

export default CashOnDelivery;
